import React from 'react';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useNavigate } from '@/hooks';
import { renderComponent } from '@/components/componentRegistry';
import { getLandingLoanOfficerConfig } from './config/landingLoanOfficerConfig';
import { ColumnLayout } from '@/components/atoms';
import { useLoan } from '@/contexts';

/**
 * LandingLoanOfficer - Landing page after loan officer selection
 * Displays a card with the same styling as the LoanOfficer page
 * Uses loan officer data from context (set in previous page)
 */
export const LandingLoanOfficer: React.FC = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { applicationData } = useLoan();

  // Get loan officer data directly from context (already set in LoanOfficer page)
  const loanOfficer = applicationData.loanOfficerData || null;

  const handleContinue = () => {
    // Navigate directly to loan setup page
    navigate('/quickloan/setup');
  };

  const handleBack = () => {
    // Navigate back to loan officer selection
    navigate('/quickloan');
  };

  const config = getLandingLoanOfficerConfig({
    theme,
    t,
    onContinue: handleContinue,
    onBack: handleBack,
    loanOfficer,
  });

  return (
    <ColumnLayout spacing="none" fullWidth fullHeight>
      {renderComponent(config, 0, false)}
    </ColumnLayout>
  );
};

export default LandingLoanOfficer;
